// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-Image-module--cls1--d0b96","cls2":"Lightbox-Image-module--cls2--12cVA Lightbox-Image-module--cls1--d0b96"};